import { useTranslation } from "react-i18next";
import { BlockbrainCredentialsInput } from "./BlockbrainCredentialsInput";

export function BlockbrainSettings() {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <div>
          <h2 className="text-2xl font-bold">{t("blockbrain.title")}</h2>
          <p className="text-muted-foreground mt-2">{t("blockbrain.description")}</p>
          <ul className="text-muted-foreground mt-1 ml-4 list-disc text-sm">
            <li>API: <code className="bg-muted px-1 rounded">POST /cortex/active-bot/{"{bot_id}"}/convo</code> + <code className="bg-muted px-1 rounded">POST /cortex/completions/user-input</code></li>
            <li>Auth: <code className="bg-muted px-1 rounded">Authorization: Bearer sk-kb-…</code></li>
            <li>Pro Avatar-Session wird automatisch eine Conversation (Data Room) angelegt.</li>
          </ul>
          <p className="text-muted-foreground mt-2 text-sm">
            Aktivieren über Backend-Variable <code className="bg-muted px-1 rounded">BLOCKBRAIN_FEATURE_ENABLED=true</code> sowie Frontend-Flag <code className="bg-muted px-1 rounded">VITE_FEATURE_BLOCKBRAIN=true</code>.
          </p>
        </div>
        <BlockbrainCredentialsInput />
      </div>
    </div>
  );
}
